const RateBar = (props) => {
    
    const { rateDetails } = props;
    let cgst = rateDetails.totalTax;
    let sgst = rateDetails.totalTax;
    cgst = (cgst / 2).toFixed(2);
    sgst = (sgst / 2).toFixed(2);

    return (
        <>
            <div className="book-bar padding-tb20 padding-lr20 margin-b20" style={{color: '#535354', fontSize: '14px', backgroundColor: '#f7f7f7'}}>
                <div className="row">
                {/* <div className="row"> */}
                    {/* <div className="col-xl-4 col-sm-5">
                        <div className="row margin-br5">
                            <div className="col-sm-4">
                                <strong className="margin-0">Total Green Fee:</strong>
                            </div>
                            <div className="col-sm-8">
                                <strong className="margin-0">₹ {rateDetails.totalAmount}</strong> <small>(incl cart & caddy)</small>
                            </div>
                        </div>
                        <div className="row margin-br5">
                            <div className="col-sm-4">
                                <strong className="margin-0">Total SGST 9%:</strong>
                            </div>
                            <div className="col-sm-8">
                                <strong className="margin-0">₹ {sgst}</strong>
                            </div>
                        </div>
                        <div className="row margin-br5">
                            <div className="col-sm-4">
                                <strong className="margin-0">Total CGST 9%:</strong>
                            </div>
                            <div className="col-sm-8">
                                <strong className="margin-0">₹ {cgst}</strong>
                            </div>
                        </div>
                        <div className="row margin-br5">
                            <div className="col-sm-4">
                                <strong className="margin-0">Total Amount:</strong>
                            </div>
                            <div className="col-sm-8">
                                <strong className="margin-0">₹ {rateDetails.finalAmount}</strong> <small>(incl GST)</small>
                            </div>
                        </div>
                    </div> */}
                    {/* <div className="col-sm-4 text-center padding-r50 padding-t20"> */}
                    {/* <div className="col-sm-4 text-center"> */}
                    <div className="col text-center">
                        <strong>{rateDetails.fromDate} To {rateDetails.toDate}</strong>
                        <br />
                        <strong>{rateDetails.type}: {rateDetails.total}</strong>
                        <br />
                    </div>
                </div>
            </div>
        </>
    );
};

export default RateBar;